export const ADD_USERS_REQUEST = 'ADD_USERS_REQUEST'
export const ADD_USERS_SUCCESS = 'ADD_USERS_SUCCESS'
export const ADD_USERS_FAILURE = 'ADD_USERS_FAILURE'
export const ADD_USERS_UPDATE = 'ADD_USERS_UPDATE'

